import React, { forwardRef } from "react";
import get from "lodash/get";

import { StyledCheckboxWrapper } from "./checkboxField.style";
import GenericInputField, {
  TYPES,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";

const CheckboxField = forwardRef(
  ({ required, options, name, readOnly, ...rest }, ref) => {
    const {
      register,
      formState: { errors },
    } = useFormContext();
    const error = get(errors, name);

    return (
      <StyledCheckboxWrapper ref={ref} error={error ? 1 : 0}>
        {options?.map((option, index) => (
          <div key={`${index}`}>
            <GenericInputField
              type={TYPES.CHECKBOX}
              register={register}
              value={option.value}
              label={option.label}
              name={name}
              required={required}
              readOnly={readOnly}
              {...rest}
            />
          </div>
        ))}
        <span className="error">{error?.message || ""}</span>
      </StyledCheckboxWrapper>
    );
  },
);
CheckboxField.displayName = "CheckboxField";

export default CheckboxField;
